<template>
  <div class="page-container flex-col">
    <div class="head-banner">
      临安区海内外高层次人才创新创业项目申报系统
    </div>

    <div class="content-box">
      <div>
        <div class="directory-box">
          <div :class="['menu-box', menuIndex == 0 && 'selected']" @click="switchMenu(0)">项目申报人基本情况</div>
          <div :class="['menu-box', menuIndex == 1 && 'selected']" @click="switchMenu(1)">项目团队核心成员基本情况</div>
          <div :class="['menu-box', menuIndex == 2 && 'selected']" @click="switchMenu(2)">项目概况</div>
          <div :class="['menu-box', menuIndex == 3 && 'selected']" @click="switchMenu(3)">项目投融资需求</div>
          <div :class="['menu-box', menuIndex == 4 && 'selected']" @click="switchMenu(4)">项目可行性分析报告</div>
          <div :class="['menu-box', menuIndex == 5 && 'selected']" @click="switchMenu(5)">附件材料</div>
        </div>
        <div class="service-box">
          <div class="title">咨询电话</div>
          <div >青山湖科技城：</div>
          <div class="phone" style="margin-bottom: 10px">0571-63785598</div>
          <div >锦南新城：</div>
          <div class="phone">0571-89542573</div>

        </div>
      </div>

      <div class="form-box">
        <applicant-base-info v-show="menuIndex == 0" ref="applicantBaseInfo" :dataInfo="dataInfo.baseApplyUser" :disabled="disabled" />
        <core-user-list v-show="menuIndex == 1" ref="coreUserList" :dataInfo="dataInfo.coreUserList" :disabled="disabled" />
        <project-base-info v-show="menuIndex == 2" ref="projectBaseInfo" :dataInfo="dataInfo.baseProject" :disabled="disabled" />
        <financing-demand v-show="menuIndex == 3" ref="financingDemand" :dataInfo="dataInfo.financing" :disabled="disabled" />
        <analysis-report v-show="menuIndex == 4" ref="analysisReport" :dataInfo="dataInfo.analysisReport" :disabled="disabled" />
        <material-list v-show="menuIndex == 5" ref="materialList" :dataInfo="dataInfo.materialList" :hasCoreUser="hasCoreUser" :disabled="disabled" />

        <div class="btn-box" v-if="!disabled">
          <el-button class="save" @click="save" :loading="submitLoading">暂存</el-button>
          <el-button v-if="menuIndex < 5" class="next" type="primary" @click="next">下一步</el-button>
          <el-button v-if="menuIndex == 5" class="next" type="primary" :loading="submitLoading" @click="submit">提交</el-button>
        </div>

      </div>
    </div>


  </div>
</template>

<script>

import { saveApply, applyDetail, tempStorage } from '@/api/HttpRequestAPI';
import {findByKey, toList, HZ_AREA_DATA, CARD_TYPE, APPLY_STATUS, MARITAL_STATUS, SOCIAL_SECURITY_TYPE, HIGHEST_EDUCATION, UNIT_AREA_TYPE,
  RELATION, HOUSE_TYPE, YES_OR_NO} from '@/constant/Enums'
import {toast} from '@/utils'
import ApplicantBaseInfo from './components/applicantBaseInfo'
import CoreUserList from './components/coreUserList'
import ProjectBaseInfo from './components/projectBaseInfo'
import FinancingDemand from './components/financingDemand'
import AnalysisReport from './components/analysisReport'
import MaterialList from './components/materialList'

export default {
  components: {
    ApplicantBaseInfo,
    CoreUserList,
    ProjectBaseInfo,
    FinancingDemand,
    AnalysisReport,
    MaterialList,
  },
  data() {
    let {type} = this.$route.meta
    let {id} = this.$route.query
    let disabled = type == 'detail'
    return {
      menuIndex:0,
      APPLY_STATUS,
      YES_OR_NO,
      UNIT_AREA_TYPE,
      id,
      disabled,
      dataInfo:{
        baseApplyUser:{
          studyExpList: [{}],//学习经历
          workExpList: [{}],//工作经历
          sbrZzqkList: [],//主持国家和地方科技业项目及资助情况
        },//申报人基本信息
        coreUserList:[{
          workAndStudyList: [{}],//个人学习及工作履历
          zzqkList: [{}],//主持国家和地方科技业项目及资助情况
          coreSfzFileIdList:[],//身份证或护照
          xlxwFileIdList:[],//学历学位证书
          zczsFileIdList:[],//职称证书
          glcgFileIdList:[],//各类成果和奖项
        }],//核心成员基本信息
        baseProject:{},//项目概况
        analysisReport:{fxbgFileIdList:[]},//可行性分析报告
        financing:{},//项目投融资需求
        materialList:{
          sbrsfzFileIdList:[],//申报人身份证件材料
          sbrxlFileIdList:[],//申报人学历材料
          xlrzzsFileIdList:[],//教育部出具的学历认证证书或留学证明材料
          zcFileIdList:[],//申报人职称
          sbrdwFileIdList:[],//申报人单位任职证明以及相关业绩证明材料
          sbrzycgFileIdList:[],//申报人主要成果
          hjzsFileIdList:[],//申报人各类获奖证书
          yyzzFileIdList:[],//已创办的企业还需提供企业相关证明材料
          hxcyFileIdList:[],//申报项目团队核心成员有关资料
          xmqkFileIdList:[],//项目情况表
          pptFileIdlList:[],//路演ppt
          otherFileIdlList:[],//其他材料
        },//材料信息
      },

      submitLoading:false,

    }
  },
  watch: {
  },
  computed: {
    hasCoreUser(){
      let userSize = 0
      this.dataInfo.coreUserList.forEach(data=>{
        if(data.name) {
          userSize++
        }
      })
      return userSize > 0
    },
  },
  mounted() {
    if(this.id) {
      this.asyncDetail()
    }
  },
  methods: {
    switchMenu(index){
      this.menuIndex = index
    },
    getParams(){
      var detail = this.deepClone(this.dataInfo)
      let params = {
        ...detail,
        commissionId:detail.baseApplyUser.commissionId
      }
      //过滤空列表
      params.baseApplyUser.studyExpList = this.filterList(params.baseApplyUser.studyExpList)
      params.baseApplyUser.workExpList = this.filterList(params.baseApplyUser.workExpList)
      params.baseApplyUser.sbrZzqkList = this.filterList(params.baseApplyUser.sbrZzqkList)
      params.coreUserList.forEach(coreUser=>{
        coreUser.workAndStudyList = this.filterList(coreUser.workAndStudyList)
        coreUser.zzqkList = this.filterList(coreUser.zzqkList)
        coreUser.coreSfzFileIdList = coreUser.coreSfzFileIdList.map(data=>data.id)
        coreUser.xlxwFileIdList = coreUser.xlxwFileIdList.map(data=>data.id)
        coreUser.zczsFileIdList = coreUser.zczsFileIdList.map(data=>data.id)
        coreUser.glcgFileIdList = coreUser.glcgFileIdList.map(data=>data.id)
      })
      Object.keys(params.materialList).forEach(function(key) {
        params.materialList[key] = params.materialList[key].map(data=>data.id)
      });
      params.analysisReport.fxbgFileIdList = params.analysisReport.fxbgFileIdList.map(data=>data.id)
      return params
    },
    save(){
      let params = this.getParams()
      this.submitLoading = true
      tempStorage(params, (resp)=>{
        toast('保存成功')
        this.$router.push('/apply-list');
        this.submitLoading = false
      }, (failResp)=>{
        this.submitLoading = false
      })
    },
    submit(){
      let totalItemList = ['applicantBaseInfo', 'coreUserList', 'projectBaseInfo', 'financingDemand', 'analysisReport', 'materialList']
      let checkItemList = ['applicantBaseInfo', 'projectBaseInfo', 'financingDemand', 'analysisReport', 'materialList']
      if(this.hasCoreUser) {
        checkItemList.splice(1, 0, 'coreUserList');
      }
      let isValid = true
      let errorMsg = ''
      let tabIndex = -1
      checkItemList.forEach((data, index)=>{
        this.$refs[data].validate((valid, object)=>{
          if(!valid && isValid) {
            totalItemList.forEach((item, itemIndex)=>{
              if(data == item) {
                tabIndex = itemIndex
              }
            })
            isValid = false
            let firstKey = Object.keys(object)[0]
            errorMsg = object[firstKey][0].message
          }
        })
      })
      if(!isValid) {
        toast(errorMsg)
        this.menuIndex = tabIndex
        window.scrollTo(0, 0);
      } else {
        this.$confirm('提交后内容将被锁定，将等待审核后才能修改，是否确认提交？', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll:false,
        }).then(()=>{
          //提交
          let params = this.getParams()
          if(!this.hasCoreUser) {
            //无核心人员
            params.coreUserList = []
          }
          this.submitLoading = true
          saveApply(params, (resp)=>{
            toast('提交成功')
            this.$router.push('/apply-list');
            this.submitLoading = false
          }, (failResp)=>{
            this.submitLoading = false
          })
        });

      }
    },

    async next() {
      let checkItemList = ['applicantBaseInfo', 'coreUserList', 'projectBaseInfo', 'financingDemand', 'analysisReport', 'materialList']
      let checkItem = checkItemList[this.menuIndex]
      if(checkItem == 'coreUserList' && !this.hasCoreUser) {
        //下一步
        this.$refs['coreUserList'].resetFields()
        this.menuIndex = this.menuIndex + 1
        window.scrollTo(0, 0);
        return
      }
      this.$refs[checkItem].validate((valid, object)=>{
        if(!valid) {
          let firstKey = Object.keys(object)[0]
          toast(object[firstKey][0].message)
        } else {
          //下一步
          this.menuIndex = this.menuIndex + 1
          window.scrollTo(0, 0);
        }
      })
    },
    //深拷贝
    deepClone(obj) {
      let _tmp = JSON.stringify(obj);//将对象转换为json字符串形式
      let result = JSON.parse(_tmp);//将转换而来的字符串转换为原生js对象
      return result;
    },
    filterList(list){
      let newList = list.filter((data)=>{
        return JSON.stringify(data) != '{}'
      })
      return newList
    },
    asyncDetail(){
      let params = {
        id:this.id,
      }
      applyDetail(params, (resp)=>{
        let detail = resp.data
        detail.baseApplyUser.commissionId = detail.commissionId
        if(detail.baseApplyUser.studyExpList.length == 0) {
          detail.baseApplyUser.studyExpList = [{}]
        } else {
          detail.baseApplyUser.studyExpList.forEach(data=>{
            if(data.startDate && data.endDate) {
              data.times = [data.startDate, data.endDate]
            }
          })
        }
        if(detail.baseApplyUser.workExpList.length == 0) {
          detail.baseApplyUser.workExpList = [{}]
        } else {
          detail.baseApplyUser.workExpList.forEach(data=>{
            if(data.startDate && data.endDate) {
              data.times = [data.startDate, data.endDate]
            }
          })
        }
        if(detail.baseApplyUser.sbrZzqkList.length == 0) {
          detail.baseApplyUser.sbrZzqkList = []
        }
        if(detail.coreUserList.length == 0) {
          detail.coreUserList = [{
            workAndStudyList: [{}],
            zzqkList: [{}],
            coreSfzFileIdList:[],//身份证或护照
            xlxwFileIdList:[],//学历学位证书
            zczsFileIdList:[],//职称证书
            glcgFileIdList:[],//各类成果和奖项
          }]
        }
        detail.coreUserList.forEach(coreUser=>{
          if(!coreUser.workAndStudyList || coreUser.workAndStudyList.length == 0) {
            coreUser.workAndStudyList = [{}]
          }
          coreUser.workAndStudyList.forEach(data=>{
            if(data.startDate && data.endDate) {
              data.times = [data.startDate, data.endDate]
            }
          })
          if(!coreUser.zzqkList || coreUser.zzqkList.length == 0) {
            coreUser.zzqkList = [{}]
          }
        })

        this.dataInfo = {
          ...detail,
        }

        this.$refs.projectBaseInfo.init()

      })
    }
  },

}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
